import React, { useState } from 'react';
import styles from './agentChat.module.css';

/** Every paragraph and list item carries its own direction (dir="auto"): a Hebrew answer on an English page is read right to left. */
/** **bold** and "- " lists, nothing else: the agent writes short, bold-first answers (answer-style). */
function inline(text, keyBase) {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => (p.startsWith('**') && p.endsWith('**') ? <strong key={`${keyBase}-${i}`}>{p.slice(2, -2)}</strong> : <React.Fragment key={`${keyBase}-${i}`}>{p}</React.Fragment>));
}

export function renderRich(text) {
  const lines = String(text || '').split('\n');
  const out = [];
  let list = [];
  const flush = () => {
    if (list.length) out.push(<ul key={`ul-${out.length}`} className={styles.list}>{list}</ul>);
    list = [];
  };
  lines.forEach((line, i) => {
    const m = /^\s*[-•]\s+(.*)$/.exec(line);
    if (m) list.push(<li key={`li-${i}`} dir="auto">{inline(m[1], `li-${i}`)}</li>);
    else {
      flush();
      if (line.trim()) out.push(<p key={`p-${i}`} className={styles.para} dir="auto">{inline(line, `p-${i}`)}</p>);
    }
  });
  flush();
  return out;
}

export default function ReplyText({ text, details, t }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.replyText}>
      {renderRich(text)}
      {details ? (
        <>
          {open && <div className={styles.details}>{renderRich(details)}</div>}
          <button type="button" className={styles.more} onClick={() => setOpen((o) => !o)} data-testid="agent-more">
            {open ? t('agent.less', { defaultValue: 'Less' }) : t('agent.more', { defaultValue: 'More' })}
          </button>
        </>
      ) : null}
    </div>
  );
}
